import React, { FC } from "react"
import { Checkbox, CheckboxProps } from "@mantine/core"

type DayOfWeekCheckboxProps = CheckboxProps

const DayOfWeekCheckbox: FC<DayOfWeekCheckboxProps> = props => (
    <Checkbox
        styles={{
            body: { flexDirection: "column", alignItems: "center", gap: "0.25rem" },
            label: { paddingLeft: 0 },
        }}
        {...props}
    />
)

export default DayOfWeekCheckbox
